import {actionHistoryType} from "./Type";

export const changeCurrentTab = (currentTab) => ({
    type: actionHistoryType.CHANGE_CURRENT_TAB,
    currentTab
})
export const changeCurrentAction = (url, tab) => ({
    type: actionHistoryType.CHANGE_CURRENT_ACTION,
    url,
    tab
})
export const onChangeForbidden = (params) => ({
    type: actionHistoryType.CHANGE_FORBIDDEN,
    params
})